<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body row-set-line">
  
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                      <div class="btn-group enrollment-list-btn-info" role="group">
                        <button type="button" class="btn"
                          [ngClass]="{'btn-primary':activeTab=='mainmenu','btn-outline-primary':activeTab!='mainmenu'}"
                          (click)="activeMenuTab(activeTab=='mainmenu'?'':'mainmenu')">Main-Menu</button>
                        <button type="button" class="btn"
                          [ngClass]="{'btn-primary':activeTab=='submenu','btn-outline-primary':activeTab!='submenu'}"
                          (click)="activeMenuTab(activeTab=='submenu'?'':'submenu')">Sub-Menu</button>
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name />
                        <button class="btn search-btn glow position-absolute">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0 reset-btn">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/control-management/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
  
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber"
                      (page)="pageChangeData($event)"></ngx-datatable>
                  </div>
                  <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Permissions Guideline</button>
                    </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Main Menus" prop="name" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="cell-line-height cursor-pointer">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row.title }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Sub Menus" prop="submenu" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <span *ngFor="let menu of row?.submenu;last as isLast">
                      {{menu?.title}}
                      <span *ngIf="menu?.title?.length>1 && !isLast">,</span>
                    </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Assign For" prop="asignfor" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <span *ngFor="let assign of row?.asignfor;last as isLast">
                      {{assign?.name}}
                      <span *ngIf="assign?.name?.length>1 && !isLast">,</span>
                    </span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Actions" [width]="80"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button [matMenuTriggerFor]="menu1"
                      class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
  
                    <mat-menu #menu1="matMenu">
                      <button mat-menu-item (click)="editJob(row)">Edit</button>                     
                      <button mat-menu-item (click)="Delete(row._id)">Delete</button>
                    </mat-menu>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  
  <!----- Job Payment Popup ----------->
  <div>
    <ng-template #myModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Transaction</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="top-content">
          <table *ngIf="payment_data">
            <tbody>
              <tr>
                <th>Net Amount :</th>
                <td>
                  <span *ngIf="payment_data[0]?.job_id?.projectbudget">{{payment_data[0]?.job_id?.projectbudget}}</span>
                </td>
              </tr>
              <tr>
                <th>Paid Amount :</th>
                <td>
                  <span class="bg-light-success"
                    *ngIf="payment_data[0]?.total_paid">{{payment_data[0]?.total_paid}}</span>
                </td>
              </tr>
              <tr>
                <th>Pending Amount :</th>
                <td>
                  <span class="bg-light-danger"
                    *ngIf="payment_data[0]?.pendingAmount">{{payment_data[0]?.pendingAmount}}</span>
                </td>
              </tr>
              <tr>
                <th>Mode :</th>
                <td>{{payment_data[0]?.mode?.displayname}}</td>
              </tr>
              <tr *ngIf="enrolmentData?.net_fees !== enrolmentData?.paid_fee">
                <th>Next Payment Date :</th>
                <td>{{enrolmentData?.next_payment_date | date :'mediumDate'}}</td>
              </tr>
            </tbody>
  
          </table>
        </div>
        <hr>
        <form>
          <div class="form-group">
            <label>Amount</label>
            <input type="text" class="form-control" [(ngModel)]="payment_model.paid_amount"
              [ngModelOptions]="{standalone: true}">
          </div>
          <div class="form-group">
            <label>Payment Mode</label>
            <ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id" placeholder="Select Payment Mode"
              [(ngModel)]="selectedPaymentMode" [ngModelOptions]="{ standalone: true }"
              (change)="getPaymentModeId($event)">
            </ng-select>
          </div>
          <div class="form-group">
            <label>Payment Status</label>
            <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name" placeholder="Select Status"
              [(ngModel)]="selectedPaymentStatus" [ngModelOptions]="{ standalone: true }">
            </ng-select>
          </div>
          <div class="form-group">
            <label>Payment Notes</label>
            <input type="text" class="form-control" [(ngModel)]="payment_model.payment_notes"
              [ngModelOptions]="{standalone: true}">
          </div>
          <div class="form-group">
            <label>Next Payment Date</label>
            <input type="date" class="form-control" [(ngModel)]="payment_model.next_paymentdate"
              [ngModelOptions]="{standalone: true}">
          </div>
        </form>
  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="payment()">Submit</button>
      </div>
    </ng-template>
  </div>
  <!----------- Attach Lead Popup --------------------->
  <div>
    <ng-template #myModal2 let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Lead Detail</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table id="table" *ngIf="lead_data">
          <tbody>
            <tr>
              <th>Lead Title :</th>
              <td>
                <span *ngIf="lead_data?.title">{{lead_data?.title}}</span>
              </td>
            </tr>
            <tr>
              <th>Lead Status :</th>
              <td>
                <span class="badge badge-pill text-capitalize bg-light-danger mr-1"
                  *ngIf="lead_data?.lead_status?.displayname">{{lead_data?.lead_status?.displayname}}</span>
              </td>
            </tr>
            <tr>
              <th>Lead Stage :</th>
              <td>
                <span class="badge badge-pill text-capitalize bg-light-primary mr-1"
                  *ngIf="lead_data?.lead_stage?.displayname">{{lead_data?.lead_stage?.displayname}}</span>
              </td>
            </tr>
            <tr>
              <th>Source :</th>
              <td>
                <span *ngIf="lead_data?.source?.displayname">{{lead_data?.source?.displayname}}</span>
              </td>
            </tr>
            <tr>
              <th>Next Action :</th>
              <td>
                <span *ngIf="lead_data?.next_action?.displayname">{{lead_data?.next_action?.displayname}}</span>
              </td>
            </tr>
            <tr>
              <th>Type :</th>
              <td>
                <span *ngIf="lead_data?.type?.displayname">{{lead_data?.type?.displayname}}</span>
              </td>
            </tr>
            <tr>
              <th>Notes :</th>
              <td [innerText]="lead_data?.notes">
              </td>
            </tr>
            <tr>
              <th>Admin Notes :</th>
              <td [innerText]="lead_data?.admin_notes">
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!lead_data">
          <small style="color: red;  margin-left: 35%;">Data Not Found!</small>
        </div>
      </div>
      <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="payment()">Submit</button>
            </div> -->
    </ng-template>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
